<div class="container">
  <app-banner
    [user]="user"
    [isValidUser]="false"
    [title]="'webCapture' | translate"
    [isWebApps]="true"
  >
  </app-banner>
  <div class="content">
    <p class="accessDenied">{{ 'accessDenied' | translate }}</p>
    <p class="contactYourAdmin">{{ 'contactYourAdmin' | translate }}</p>
  </div>
</div>
